(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dunisca-estilo"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var enlace = e.target instanceof Element ? e.target.closest('[data-dunisca-variante]') : null;
    if (!enlace) return;
    var radio = document.querySelector(
      'variant-picker input[type="radio"][data-variant-id="' + enlace.dataset.duniscaVariante + '"]'
    );
    if (!radio) return;
    e.preventDefault();
    if (!radio.checked) radio.click();
    var destino = radio.closest('variant-picker') || radio;
    var arriba = destino.getBoundingClientRect().top + window.scrollY - 140;
    window.scrollTo({ top: Math.max(arriba, 0), behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
